
import { RepsField } from "./RepsField";
import { WeightField } from "./WeightField";

interface ModalFormFieldsProps {
  localReps: string;
  localWeight: string;
  exerciseId: string;
  setIndex: number;
  onRepsChange: (value: string) => void;
  onWeightChange: (value: string) => void;
}

export const ModalFormFields = ({
  localReps,
  localWeight,
  exerciseId,
  setIndex,
  onRepsChange,
  onWeightChange
}: ModalFormFieldsProps) => {
  return (
    <div className="space-y-6">
      <RepsField
        value={localReps}
        onChange={onRepsChange}
      />
      
      <WeightField
        value={parseFloat(localWeight) || 0}
        onChange={onWeightChange}
        exerciseId={exerciseId}
        setIndex={setIndex}
      />
    </div>
  );
};
